export default "__VITE_ASSET__DuV6GU5o__"